import Raven from 'raven-js';
import { useGetAllQuery } from '../../__generated__/chirp/com/hubspot/piesync/bridge/rpc/AppsRpc.hooks';
export const useDataSyncApps = args => {
  var _args$skip;
  const {
    data,
    loading,
    error,
    networkStatus
  } = useGetAllQuery({
    onError: err => {
      Raven.captureException(err);
    },
    skip: (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false
  });
  return {
    data: (data === null || data === void 0 ? void 0 : data.apps) || [],
    error,
    isLoading: loading,
    networkStatus
  };
};